import React from 'react';
import { useTranslation } from 'react-i18next';
import { MarketList } from '@market/react';
import StepRow from './StepRow';
import StepThree from 'svgs/referrals/StepThree';
import StepTwo from 'svgs/referrals/StepTwo';
import StepOne from 'svgs/referrals/StepOne';

const HowItWorks: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="space-y-6 mt-12">
      <h3 className="text-2xl font-bold text-gray-900">
        {t('refer.howItWorks.title')}
      </h3>
      <MarketList className="referral-steps">
        <StepRow label={t('refer.howItWorks.step1')} Icon={StepOne} />
        <StepRow label={t('refer.howItWorks.step2')} Icon={StepTwo} />
        <StepRow label={t('refer.howItWorks.step3')} Icon={StepThree} />
      </MarketList>
      <p className="text-gray-600 text-[12px]">{t('refer.footer')}</p>
    </div>
  );
};

export default HowItWorks;
